import React, { useEffect, useState } from 'react';
import { TransactionTableDTO, TransactionPage } from '@/types/TransactionTableDTO';
import { fetchTransactionTable } from '@/services/api/transactionApi';
import TransactionsList from '@/components/accounts/TransactionsList';
import Pagination from '@/components/ui/Pagination';
import TransactionFilters, { TransactionFilterValues } from '@/components/transactions/TransactionFilters';

const Transactions: React.FC = () => {
  const [transactions, setTransactions] = useState<TransactionTableDTO[]>([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // ✅ Filters state
  const [filters, setFilters] = useState<TransactionFilterValues>({
    merchantName: '',
    category: '',
    startDate: '',
    endDate: ''
  });

  // ✅ Fetch transactions with filters
  const loadTransactions = async (pageNum = 0, pageSize = size) => {
    try {
      setIsLoading(true);

      // Build filter payload to send as query params
      const filterPayload: Record<string, string> = {};
      if (filters.merchantName) filterPayload.merchantName = filters.merchantName;
      if (filters.category) filterPayload.category = filters.category;
      if (filters.startDate) filterPayload.startDate = filters.startDate;
      if (filters.endDate) filterPayload.endDate = filters.endDate;

      const result: TransactionPage = await fetchTransactionTable(pageNum, pageSize, filterPayload);

      setTransactions(result.content);
      setPage(result.number);
      setTotalPages(result.totalPages);
      setTotalElements(result.totalElements);
    } catch (err) {
      console.error('❌ Failed to load transactions', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTransactions(0, size); // initial load
  }, [size]);

  // ✅ When user clicks a page number
  const handlePageChange = (newPage: number) => {
    loadTransactions(newPage, size);
  };

  // ✅ When user selects a new page size
  const handlePageSizeChange = (newSize: number) => {
    setSize(newSize);
    loadTransactions(0, newSize);
  };

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Transactions</h1>

      {/* ✅ Reusable Filters Component */}
  <TransactionFilters
  filters={filters}
  onChange={setFilters}
  onApply={() => loadTransactions(0, size)}
  onClear={() => {
    setFilters({ merchantName: '', category: '', startDate: '', endDate: '' });
    loadTransactions(0, size);
  }}
/>


      <TransactionsList transactions={transactions} isLoading={isLoading} />

      <Pagination
        currentPage={page + 1}
        totalPages={totalPages}
        pageSize={size}
        totalItems={totalElements}
        onPageChange={(p) => handlePageChange(p - 1)}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

export default Transactions;
